export default __webpack_public_path__ + "static/media/SamsungOne-400_v1.0.960d3d13.ttf";